import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GridApi } from 'ag-grid-community';
import { UmSummaryService } from 'src/app/services/um/um-summary.service';
import { CommonService } from 'src/app/services/common.service';
import { City, ZipResponse } from 'src/app/models/common';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { MessageBoxComponent } from 'src/app/common/message-box/message-box.component';
import { UmOrganizationViewModalComponent } from './um-organization-view-modal/um-organization-view-modal.component';
import { UmOrganizationPasswordPolicyViewModalComponent } from './um-organization-password-policy-view-modal/um-organization-password-policy-view-modal.component';
import { UserService } from 'src/app/services/user.service';
import { DeleteBoxComponent } from 'src/app/common/delete-box/delete-box.component';
import { SupportUsersModalComponent } from './support-users-modal/support-users-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsService } from 'src/app/services/administration/analytics.service';

@Component({
  selector: 'app-um-organization',
  templateUrl: './um-organization.component.html',
  styleUrls: ['./um-organization.component.scss']
})
export class UmOrganizationComponent implements OnInit {
  collapesedOrNot: boolean;
  columnDefs;
  operations;
  loperations;
  gridApi: GridApi;
  selectedRow;
  rowData;
  userType: string;
  advanceSearch;
  city: City;
  zipresponse: ZipResponse;
  orgForm: UntypedFormGroup;
  isSettings: boolean = true;
  isSuperAdmin: boolean;
  Statuslist: any = [];
  OrganisationName:string;
  user;
  constructor(
    private userService: UserService,
    public route: ActivatedRoute,
    private summaryService: UmSummaryService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private analyticsService : AnalyticsService
  )
  {
  }
  
  ngOnInit() {
    this.Statuslist = [
      { "value": "-1", "label": "All" },
      { "value": "1", "label": "Active" },
      { "value": "0", "label": "Inactive" }
    ];
    this.collapesedOrNot = false;
    this.orgForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      Status: new UntypedFormControl("-1")
    });

    if (this.userService.getUserDetais().USER_TYPE === "A") {
      this.isSuperAdmin = true;
    }
    else {
    this.isSuperAdmin = false;
    }

    this.columnDefs = [
      {
       "headerName": "Code",
       "field": "CODE"
     }, 
     {
       "headerName": "Organization Name",
       "field": "NAME"
     },
     {
       "headerName": "Status",
       "field": "STATUS"
     },
     {
       "headerName": "Programs Enabled",
       "field": "PROGENABLED"
     },
     {
       "headerName": "Application Validity",
       "field": "LICENCE_END_DATES"
     }
   ];

   var formData = this.orgForm.value;
   this.setSearchSummary(formData);
  }

  setOperations(rowData: any[]) {
    this.user = this.userService.getUserDetais();
    if (this.user.USER_TYPE === "A") {
    this.operations = [];
    this.operations.push({
      "name": "Add New Organisation",
      "id": "add"
    });
    this.operations = this.operations.map(operation => {
      return (operation && ((operation.id === 'add' || operation.id === 'view_modal') && this.user.USER_TYPE !== "I")) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }
    this.loperations = [];
    // if(this.commonService.getScreenPermission("101","E")){
    //   this.isSettings = true;
    //   this.loperations.push({
    //     "name": "Edit",
    //       "id": "edit"
    //   });
    // }
    this.user = this.userService.getUserDetais();
    
    rowData.forEach(element =>{
      this.loperations=[];
      if (this.user.USER_TYPE === "A") {
        this.isSettings = true;
        this.loperations.push({
          "name": "Add New Organisation",
          "id": "add"
        });
        this.loperations.push({
          "name": "Edit",
          "id": "edit"
        });
        this.loperations.push({
          "name": "Users",
          "id": "support_users"
        });
      }
      if (this.user.USER_TYPE !== null && this.user.USER_TYPE !== undefined && this.user.USER_TYPE === "I") {
        element["Operations"] = this.loperations.map(operation => {
          return (operation && ((operation.id === 'add' || operation.id === 'view_modal') && this.user.USER_TYPE !== "I")) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      }
      else if (this.user.USER_TYPE === "A") {
        if(element.IS_ANALYTICS_CONFIGURED == true && element.IS_ORG_ACCOUNT_IN_LOGI == true && element.IS_UPDATE_ANALYTICS == false)
        {
          this.loperations.push({
            "name": "Sync Dashboards",
            "id": "syncDashboards"
          });
        }
        if(element.IS_ANALYTICS_CONFIGURED == true && element.IS_ORG_ACCOUNT_IN_LOGI == false && element.CANREFRESH == true)
        {
          this.loperations.push({
            "name": "Refresh",
            "id": "refresh"
          });
        }
        this.operations = this.loperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
        element["Operations"] = this.loperations.map(operation => {
          return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
        });
      }
    })

    this.rowData=rowData;

  }

  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }

  onRowDoubleClicked(event) {
    if(!this.modalService.hasOpenModals())
    {
      let modalRef = this.modalService.open(UmOrganizationViewModalComponent, {
        backdrop: false,
        keyboard: false,
        windowClass:'modal-vlg right modal-right',
        animation: true
      });
      modalRef.componentInstance.Content={
        heading: 'Edit',
        content: { id: this.selectedRow['ID'] }
      }
      modalRef.result.then(result=>{
        var formData = this.orgForm.value;
        this.setSearchSummary(formData);
      })
    }
   
  }
  
  add() {
    let modalRef = this['self'].modalService.open(UmOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content= {
      heading: 'Add',
      content: null
    }
    modalRef.result.then(result=>{
      var formData = this['self'].orgForm.value;
      this['self'].setSearchSummary(formData);
    })
  }

  edit() {
    
    let modalRef = this['self'].modalService.open(UmOrganizationViewModalComponent, {
      backdrop: false,
      keyboard: false,
      windowClass:'modal-vlg right modal-right',
      animation: true
    });
    modalRef.componentInstance.Content={
      heading: 'Edit',
      content: { id: this['self'].selectedRow['ID'] }
    }
    modalRef.result.then(result=>{
      var formData = this['self'].orgForm.value;
      this['self'].setSearchSummary(formData);
    })
  }
  
  delete() {
    const modalRef = this['self'].modalService.open(DeleteBoxComponent,{backdrop: false});
    modalRef.result.then(result => {
      this['self'].summaryService.deleteOrgSummary(this['self'].selectedRow._id).subscribe(result => {
        if (result.Status === 0) {
          this['self'].commonService.SuccessBanner('Selected Records has been deleted')
          this['self'].setSummary("");
        }
        else {
          this['self'].commonservice.ValidationBanner(result.Message);
        }
      });
    });
  }

  active() {
    this['self'].selectedRow.org_status = "Active";
    this['self'].commonService.activeFeature("ORGANIZATION", this['self'].selectedRow.ID).subscribe(result => {
      this['self'].setSearchSummaryMessage(this['self'].orgForm.value, 'Selected Records has been made Active');
    });
  }

  inactive() {
    this['self'].selectedRow.org_status = "Inactive";
    this['self'].commonService.inactiveFeature("ORGANIZATION", this['self'].selectedRow.ID).subscribe(result => {
      this['self'].setSearchSummaryMessage(this['self'].orgForm.value, 'Selected Records has been made InActive' );
    });
  }

  password_policy(){
    const modalRef = this['self'].modalService.open(UmOrganizationPasswordPolicyViewModalComponent, {
      windowClass: 'modal-llg right modal-right'
    });
    modalRef.componentInstance.Content={
      heading: 'Password Policy',
      content: { heading: '', description: 'Work in Progress', id: this['self'].selectedRow['ID'] }
    }
  }

  support_users(event){
    if(!this['self'].modalService.hasOpenModals())
    {
      let modalRef = this['self'].modalService.open(SupportUsersModalComponent, {
        windowClass: 'modal-xl right modal-right'
      });
      modalRef.componentInstance.Content={
        heading: 'Support Users',
        content: { heading: 'View', id: this['self'].selectedRow['ID'],OrgData:this['self'].selectedRow }
      }
    }
  
  }

  setSummary(filter: string){
    this.summaryService.getOrgSummary(filter).subscribe(summary=>{
     // this.rowData = summary;
      this.selectedRow = null;
     this.setOperations(summary);
    });
  }

  setSearchSummary(formData) {
    this.summaryService.getOrgSearchSummary(formData).subscribe(summary => {
     // this.rowData = summary;
      this.setOperations(summary);
    });
  }

  setSearchSummaryMessage(formData, msg) {
    this.summaryService.getOrgSearchSummary(formData).subscribe(summary => {
     // this.rowData = summary;
      this.setOperations(summary);
      const Modalref= this.modalService.open(MessageBoxComponent, {
      });
      Modalref.componentInstance.Content =  { heading: 'Active', content: { heading: '', description: msg} }
      this.selectedRow = null;
    });
   
   
  }

  setSearch() {
    this.SearchClear();
    this.selectedRow = null;
      this.summaryService.getOrgSearchSummary(this.orgForm.value).subscribe(summary => {
       // this.rowData = summary;
        this.setOperations(summary);
        this.selectedRow = null;
    });
  }

  //// Advace search Functions
  SearchClear() {
    this.orgForm = new UntypedFormGroup({
      CODE: new UntypedFormControl(""),
      NAME: new UntypedFormControl(""),
      Status: new UntypedFormControl("-1")
    });
    this.selectedRow = null;
  }
  AdvanceSearch() {
    this.setSearchSummary(this.orgForm.value);
  }

  syncDashboards(){
    var Orgdetails:any = new Object();
    Orgdetails.OrgId =  this['self'].selectedRow['ID'];
    Orgdetails.OrgName = "";
    this['self'].analyticsService.postOrgDetails(Orgdetails).subscribe(response =>{
      if(response.Status == 0){
        this['self'].commonService.SuccessBanner("Synching process started successfully.");
        var formData = this['self'].orgForm.value;
        this['self'].setSearchSummary(formData);
      }else{
        this['self'].commonService.ValidationBanner("Synching process started un-successfully.");
      }
    })
  }

  refresh(){
    this.OrganisationName = this['self'].selectedRow['NAME'];
    var Orgdetails:any = new Object();                                                                                  
    Orgdetails.OrgId =  this['self'].selectedRow['ID'];
    Orgdetails.OrgName = this['self'].selectedRow['NAME'];
    Orgdetails.IST = this['self'].selectedRow['IST'];
    Orgdetails.EAP = this['self'].selectedRow['EAP'];
    Orgdetails.GRANTS = this['self'].selectedRow['GRANTS'];
    Orgdetails.IS_ORG_ACCOUNT_IN_LOGI = this['self'].selectedRow['IS_ORG_ACCOUNT_IN_LOGI'];
    this['self'].analyticsService.refreshOrgDetails(Orgdetails).subscribe(response =>{
      if(response.Status == 0){
        this['self'].commonService.SuccessBanner("Analytics account created successfully for the organization "+ this.OrganisationName)
      }else{
        this['self'].commonService.ValidationBanner("The analytics account is not created for the organization "+ this.OrganisationName +". Please refresh the details to create an account.");
      }
    })
  }
}
